
import * as React from 'react';
import styled from 'styled-components';
import { AgGridReact } from 'ag-grid-react';
import { type ColDef, themeAlpine } from 'ag-grid-community';
import '@process-advisor/process-miner/shared/gridStyles.css'
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';


const Wrapper = styled.div<{ height: string }>`
    height: ${({ height }) => height};
    width: 100%;
`;

type SingleRow = {
    id: number;
    [key: string]: any
}

type Props = {
    rows: SingleRow[];
    columns: ColDef[];
    height: string;
    setSaveDisabled: (value: boolean) => void;
    setNextDisabled: (value: boolean) => void;
    setDeleteDisabled: (value: boolean) => void;
    step: number;
}

export const DataGrid: React.FC<Props> = ({
    rows,
    columns,
    height,
    setSaveDisabled,
    setNextDisabled,
    setDeleteDisabled,
    step,

}) => {
    const onModelUpdated = (params) => {
        // this should only be triggered if the EventLog component is active, not the UploadFile component
        if (step !== 0) {
            if (apiProvider.validateDataTransformation() === true) {setNextDisabled(false)} else {setNextDisabled(true)}
        }  
        if (params.api.getDisplayedRowCount() > 0) {setSaveDisabled(false)} else {setSaveDisabled(true)}; 
        params.api.autoSizeAllColumns();
    }

    const onSelectionChanged = (params) => {
        const selectedNodes = params.api.getSelectedNodes();
        const selectedData = selectedNodes.map(node => node.data);
        setDeleteDisabled(false);
        apiProvider.setDeleteTransformationRow({mapping: selectedData[0].mapping});
    };    
    
    return (
        <Wrapper height={height}>
            <div
                
                style={{
                    height: '100%',
                    fontSize: '12px',
                    fontFamily: 'system-ui'
,
                }}>
                <AgGridReact theme={themeAlpine} 
                    onModelUpdated={onModelUpdated}
                    rowSelection="single"
                    onSelectionChanged={onSelectionChanged}
                    columnDefs={columns}
                    headerHeight={40}
                    defaultColDef={{
                        sortable: true,
                        filter: true,
                        flex: 1,
                        minWidth: 100,
                        resizable: true,
                    }}
                    rowData={rows} />
            </div>
        </Wrapper>
    );
};
